import { render, staticRenderFns } from "./CustomFloatAvatar.vue?vue&type=template&id=07b2d0cc&scoped=true"
import script from "./CustomFloatAvatar.vue?vue&type=script&lang=js"
export * from "./CustomFloatAvatar.vue?vue&type=script&lang=js"
import style0 from "./CustomFloatAvatar.vue?vue&type=style&index=0&id=07b2d0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2d0cc",
  null
  
)

export default component.exports